export function isBlank(s?: string | null): boolean {
	return !s || /^\s*$/.test(s);
}
